<template>
  <div class="row global-map">
    <div class="col-12 title">
      {{ $t('results.globalMap') }}
    </div>
    <div class="col-12 pt-2 pb-5">
      <div id="statistic-map" style="width: 100%; height: 400px;"></div>
    </div>
  </div>
</template>

<script>
const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

export default {
  data () {
    return {
      map: null
    }
  },
  computed: {
    participantsByLocation () {
      return this.$store.getters.getParticipantsByLocation
    }
  },
  methods: {
    loadMap () {
      let self = this

      mapboxgl.accessToken = process.env.VUE_APP_MAP_BOX_TOKEN

      this.map = new mapboxgl.Map({
        container: 'statistic-map',
        zoom: 1.2,
        center: [0, 20],
        style: 'mapbox://styles/mapbox/light-v10'
      })

      this.map.on('load', function () {
        self.map.addSource('covid-people', {
          type: 'geojson',
          data: self.participantsByLocation,
          cluster: true,
          clusterMaxZoom: 14, // Max zoom to cluster points on
          clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
          clusterProperties: {
            sum: ['+', ['get', 'people'], '2']
          }
        })

        self.map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'covid-people',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': '#2bb1c4',
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              20,
              100,
              30,
              750,
              40
            ]
          }
        })

        self.map.addLayer({
          id: 'cluster-count',
          type: 'symbol',
          source: 'covid-people',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{sum}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12
          }
        })

        self.map.addLayer({
          'id': 'people_circle',
          'type': 'circle',
          'source': 'covid-people',
          'filter': ['!=', 'cluster', true],
          'paint': {
            'circle-color': '#2bb1c4',
            'circle-opacity': 1,
            'circle-radius': 12
          }
        })

        self.map.addLayer({
          id: 'people_label',
          type: 'symbol',
          source: 'covid-people',
          filter: ['!=', 'cluster', true],
          layout: {
            'text-field': [
              'number-format',
              ['get', 'people'],
              { 'min-fraction-digits': 0, 'max-fraction-digits': 0 }
            ],
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12
          },
          paint: {
            'text-color': 'black'
          }
        })
      })
    }
  },
  mounted () {
    this.loadMap()
  },
  watch: {
    participantsByLocation: function () {
      if (this.map.getSource('covid-people')) {
        this.map.getSource('covid-people').setData(this.participantsByLocation)
      }
    }
  }
}
</script>

<style>
.global-map .title {
  font-weight: 700;
  font-size: 1.2rem !important;
}
</style>
